import { ArticleType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import { ConfigEntryType } from 'config/config';
import * as Yup from 'yup';

export const getPredefinedFieldValidation = ({
  field,
  isCreatingOrEditingPlaylist,
}: {
  field: ConfigEntryType;
  isCreatingOrEditingPlaylist: boolean;
}) => {
  switch (field.entryCode) {
    case 'title': {
      return field?.referenceObject?.isRequired ||
        field?.referenceObject?.isRequired === undefined ||
        isCreatingOrEditingPlaylist
        ? Yup.string().required('Title is required')
        : Yup.string();
    }

    case 'description': {
      return field.referenceObject?.isRequired && !isCreatingOrEditingPlaylist
        ? Yup.string().required('Required field')
        : Yup.string();
    }

    case 'attachments':
    case 'playListArticles': {
      return field.referenceObject?.isRequired && !isCreatingOrEditingPlaylist
        ? Yup.array(Yup.object())
            .min(
              1,
              field.entryCode === 'attachments'
                ? 'Please upload at least one file'
                : 'Required field',
            )
            .required('Required field')
        : Yup.array(Yup.object());
    }

    default: {
      return null;
    }
  }
};

export const getPredefinedFieldDefaultValue = ({
  article,
  defaultPlaylists,
  defaultProjectId,
  field,
}: {
  article?: ArticleType;
  defaultPlaylists?: { label: string; value: string }[];
  defaultProjectId?: string;
  field: ConfigEntryType;
}) => {
  switch (field.entryCode) {
    case 'title': {
      return article?.title || '';
    }

    case 'description': {
      return article?.description || '';
    }

    case 'marketSector':
    case 'region':
    case 'topics':
    case 'projectPhases':
    case 'divisions':
    case 'specSections':
    case 'partnerIds':
    case 'playListArticles':
    case 'attachments': {
      return (
        article?.[field.entryCode] ||
        (Array.isArray(article?.customFields?.[field.entryCode]?.fieldValue)
          ? article?.customFields?.[field.entryCode]?.fieldValue
          : [])
      );
    }

    case 'playListArticleIds': {
      return defaultPlaylists?.map((item) => item.value) || article?.playListArticleIds || [];
    }

    case 'projectId': {
      return defaultProjectId || article?.projectId || '';
    }

    default: {
      return null;
    }
  }
};
